import styled from "@emotion/styled";

import { Modal } from "../Modal/Modal";

export const TokenSelectModal = styled(Modal)`
  text-align: initial;

  .ant-modal-header {
    border-bottom: none;
    border-radius: 8px;
    padding: 16px 0 20px 25px;
    .ant-modal-title {
      font-size: 20px;
      font-weight: 800;
      line-height: 32px;
      color: #06d6a0;
    }
  }

  .ant-modal-content {
    border-radius: 8px;
  }
`;
